const G = (id) => `https://static.prod-images.emergentagent.com/jobs/b9979ec9-3304-4896-8d2c-2eeafd09334a/images/${id}.jpeg`;

export const POSTS = [
  {
    slug: "what-is-diy-modular-furniture",
    title: "What is DIY modular furniture? A simple guide for Indian homes",
    excerpt: "Flat-pack, ready-to-assemble, modular: what the words mean, and why they suit small city flats.",
    date: "2026-06-02",
    read: 4,
    tag: "Guides",
    image: G("6be6ba596baa71320da358c0fd19abb691dcacda0019efa6312185d245544391"),
    body: [
      ["p", "Modular furniture is built from standard parts that fit together and can be added to later. DIY, or ready-to-assemble, means it reaches you flat-packed and you put it together at home."],
      ["h2", "Modular vs. built-in carpentry"],
      ["p", "Carpenter-made furniture is fixed to one room and one layout. Modular pieces move with you, come apart with the same hex key, and grow one shelf at a time."],
      ["h2", "Why it suits Hyderabad flats"],
      ["p", "A flat box fits most lifts and staircases, from Gachibowli high-rises to older Secunderabad buildings. There's no sawdust, no week-long fitting, and no waiting for a carpenter's slot."],
      ["h2", "What to look for"],
      ["ul", ["Numbered parts and an illustrated guide", "Bolted joints, not glue, so it can be rebuilt", "A wall anchor kit for tall pieces", "Add-ons that fit the same system"]],
    ],
  },
  {
    slug: "how-to-style-a-bookshelf-in-a-2bhk",
    title: "How to style a bookshelf in a 2BHK without making it look cluttered",
    excerpt: "Seven shelves, one rule of thirds, and a few plants. A styling plan for small Indian living rooms.",
    date: "2026-06-09",
    read: 5,
    tag: "Styling",
    image: G("e193e9e8e017a2b481bfe6a782c05b8d9c27f08567f1c68f5bdfcad38cd498c8"),
    body: [
      ["p", "An open bookshelf is the easiest way to give a rented flat some personality. The trick is leaving space."],
      ["h2", "Fill only two-thirds"],
      ["p", "Keep roughly a third of every shelf empty. Books look curated, not crammed, and you have room to grow."],
      ["h2", "Mix vertical and horizontal stacks"],
      ["p", "Stand most books upright, then lay a small stack flat and put a brass diya or a Kondapalli toy on top."],
      ["h2", "Plants go high, heavy things go low"],
      ["ul", ["Money plants and pothos trail nicely from the top two shelves", "Store heavy albums and boxes on the bottom shelf", "Anchor the rack to the wall if you have kids or pets"]],
    ],
  },
  {
    slug: "flat-pack-furniture-assembly-tips",
    title: "Flat-pack furniture assembly: 7 tips for a one-evening build",
    excerpt: "Unbox smart, sort the hardware and build as two. How to put flat-pack furniture together without a carpenter.",
    date: "2026-06-16",
    read: 4,
    tag: "How-to",
    image: G("aec839106974ec8000068a0a088ec8519fd8f1b8e6d3704785b400f4fafc2f13"),
    body: [
      ["p", "Most flat-pack builds go wrong in the first ten minutes, not the last. Here's how we test every H&W build."],
      ["ol", ["Clear a floor space twice the size of the finished piece", "Open the box flat and lay parts out by number", "Pour screws into a steel bowl so nothing rolls away", "Read the whole guide once before you start", "Hand-tighten everything first, then tighten fully at the end", "One person holds, one turns the key", "Fix the wall anchor before you load the shelves"]],
      ["p", "Stuck on a step? Email care@hwfurniture.in with a photo and we'll help the same day."],
    ],
  },
  {
    slug: "modular-furniture-vs-carpenter-cost-hyderabad",
    title: "Modular furniture vs. carpenter-made: what it really costs in Hyderabad",
    excerpt: "Material, labour, time and moving costs compared, so you can choose with real numbers.",
    date: "2026-06-23",
    read: 6,
    tag: "Buying guide",
    image: G("dec9775b91b760b359f54bf7a8a1370392971680192afacf49d192b491595eb8"),
    body: [
      ["p", "A carpenter-made bookshelf can look cheaper on the first quote. The full cost tells a different story."],
      ["h2", "What a carpenter quote often leaves out"],
      ["ul", ["Material wastage and extra visits", "Days of noise and dust in your flat", "Polish or laminate as a separate line item", "The cost of leaving it behind when you move"]],
      ["h2", "What DIY modular furniture costs"],
      ["p", "The Pustak Rack is ₹4,999 + GST with free delivery in Hyderabad within 24 hours. You build it in about 40 minutes and take it with you when you move."],
    ],
  },
];
